export const checkEmailDomainMismatch = (
  email: string,
  domain: string,
): boolean => {
  const emailParts = email?.split('@');

  if (!emailParts || emailParts.length !== 2) {
    return false;
  }

  return emailParts[1] !== domain;
};
